import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import analytics from '../../../../modules/analytics';
import {
  Button,
  BodyText,
  ButtonAppearance,
} from '../../../ui';
import { ConnectionTapToPayIcon } from '../../../ui/Icons';
import { useTapToPay } from './useTapToPay';
import Currency from '../../../../modules/Currency';

export const StartTapToPayFlowButton: React.FC<{
  disabled: boolean,
  total: number,
  appearance?: ButtonAppearance,
  showTotal?: boolean,
  onClick?: () => void,
}> = ({
  disabled,
  total,
  appearance = 'outline-thin',
  showTotal = true,
  onClick = () => {},
}) => {
  const tapToPay = useTapToPay();

  const handleTapToPayClick = () => {
    analytics.track('pro_checkout_with_tap_to_pay_clicked');
    tapToPay.startTapToPayFlow();
    onClick();
  };

  const textAndIconColor = React.useMemo(() => {
    if (disabled) {
      return BrandColor.Silver;
    }

    if (appearance === 'primary-neue') {
      return BrandColor.WhiteWash;
    }

    return BrandColor.BackInBlack;
  }, [
    disabled,
    appearance,
  ]);

  return (
    <Box color={BrandColor.WhiteWash}>
      <Button
        appearance={appearance}
        size="large"
        testID="tap-to-pay-start"
        onClick={handleTapToPayClick}
        disabled={disabled}
      >
        <Inline
          flex={1}
          alignItems="center"
          justifyContent="center"
          padding={8}
        >
          <Box paddingRight={16}>
            <ConnectionTapToPayIcon color={textAndIconColor} height={20} width={24} />
          </Box>
          <BodyText color={textAndIconColor} weight="bold" textTransform="none">
            Tap to Pay on iPhone{showTotal ? `: ${Currency.format(total)}` : null}
          </BodyText>
        </Inline>
      </Button>
    </Box>
  );
};
